import type {RouteLocationNormalized} from 'vue-router';

export type RedirectionToBeDone = {
    redirect: boolean;
    url?: string;
};

export function getMaybeRedirection(to: RouteLocationNormalized, host: string, queryParameters: string): RedirectionToBeDone {
    if (to && to.path) {
        const signupRedirectionPaths = ['/creation', '/completion', '/signup', '/maturity'];
        // With baseURL '/', profile pages live under /profile/... so strip that prefix for legacy path matching.
        const pathWithoutProfilePrefix = to.path.replace(/^\/profile(?=\/|$)/, '') || '/';
        const isPathAboutSignup = signupRedirectionPaths.some(
            (path) => pathWithoutProfilePrefix === path.toLowerCase() || pathWithoutProfilePrefix.startsWith(path + '/'),
        );
        if (isPathAboutSignup) {
            // Old funnel steps (/signup/headline, /completion, …) have no equivalent
            // nested path under freelancer-signup. Always land on the funnel index.
            return {
                redirect: true,
                url: `${host}/profile/freelancer-signup?${queryParameters}`,
            };
        }
    }
    return {
        redirect: false,
    };
}
